
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/embed/[id]",
      function () {
        return require("private-next-pages/event/embed/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/embed/[id]"])
      });
    }
  